import React from "react";
import { Office } from "../../../models/office.model";

interface InvoiceOfficeHeaderProps {
  office: Office | null;
  showHst?: boolean;
  showHstAlways?: boolean; // Shows HST if taxNumber exists, without checking taxEnabled
  showWsib?: boolean;
}

/**
 * Reusable component for displaying office details in invoice headers.
 * Used across InvoiceForm, InvoicePdf, and PatientInvoicePdf.
 */
const InvoiceOfficeHeader = ({ office, showHst = false, showHstAlways = false, showWsib = false }: InvoiceOfficeHeaderProps) => {
  if (!office) return null;

  const shouldShowHst = showHstAlways ? !!office.taxNumber : showHst && office.taxNumber && office.taxEnabled;

  return (
    <div>
      <h2 className="text-xl mb-1 font-semibold">{office.name}</h2>
      <p className="font-light">{office.street}</p>
      {office.street1 && <p className="font-light">{office.street1}</p>}
      <p className="font-light mb-2">{[office.city, office.state, office.zip].filter(Boolean).join(", ")}</p>
      <p className="font-light">{`Phone: ${office.phone ?? "-"}`}</p>
      <p className="font-light mb-2">{`Fax: ${office.fax ?? "-"}`}</p>
      {shouldShowHst && <p className="font-light mb-2"> HST # {office.taxNumber}</p>}
      {showWsib && office.wsibNumber && (
        <div>
          <p className="text font-semibold">WSIB# {office.wsibNumber}</p>
        </div>
      )}
    </div>
  );
};

export default InvoiceOfficeHeader;
